import { roomOfSession, type WorldRoomDirectory } from "@cleo/contracts";
import { workroomAccentVariable } from "./workroomAccent";

/** FD36 revised 2026-09-04: color belongs to the session's room boundary.
 * General/local sessions share Cleo's theme-resolved identity (orange by
 * default); skill sessions use their room's skill color. Content-tab
 * selection, agent identity and folding never change a session's accent.
 */
export const SESSION_ACCENT_VARIABLE = "--cleo-identity";
export const WORLD_ACCENT_READ = "var(--ncl-world-accent, var(--ncl-accent, var(--primary)))";

export function sessionAccentVariable(
  sessionId: string,
  index?: WorldRoomDirectory | null,
): string {
  const room = index ? roomOfSession(index, sessionId) : undefined;
  return room?.kind === "workroom" && room.workroomKey
    ? workroomAccentVariable(room.workroomKey)
    : SESSION_ACCENT_VARIABLE;
}

export function sessionAccentRead(sessionId: string, index?: WorldRoomDirectory | null): string {
  return `var(${sessionAccentVariable(sessionId, index)})`;
}

/** Repoint the merge mark only when that cannot create a CSS variable cycle. */
export function railRowAccentStyle(variable: string): Readonly<Record<string, string>> {
  if (variable === "--ncl-world-accent") return { "--rail-accent": WORLD_ACCENT_READ };
  const read = `var(${variable})`;
  return { "--rail-accent": read, "--ncl-world-accent": read };
}

/**
 * FD-CAN-39 (the principal 2026-09-02: "the border, use the neucleos blue" /
 * "the orange text is just too much"): THE SESSION RAIL'S ACCENT — one seat
 * for every session chip (the active one included), the FD-CAN-20 menu, and
 * the conversation card the addressed chip carves into (FD-CAN-29 (2),
 * dated), so chip and card can never disagree. The Neucleos identity: a
 * session's face is the World's system; agent rails separately follow their
 * session or skill boundary (FD36). Currency stays intensity on this one hue
 * (the FD-CAN-13 ladder), never a second hue and never a white border.
 */
export const SESSION_RAIL_ACCENT_VARIABLE = "--neucleos-identity";
export const SESSION_RAIL_ACCENT_READ = `var(${SESSION_RAIL_ACCENT_VARIABLE})`;
